import styled from 'styled-components';

export const StyledPremiumBadgeContainer = styled.div`
  text-align: center;
`;
